import { MembershipPlanId } from '../pricing/membershipPlanId'

export const plans = [
	{
		id: MembershipPlanId.STARTER,
		label: 'Starter',
		activeStyles: 'bg-line text-dark',
		inactiveStyles: 'bg-line text-dark',
		borderColor: 'border-line',
		highlightColor: 'bg-line',
	},
	{
		id: MembershipPlanId.BUSINESS,
		label: 'Business',
		activeStyles: 'bg-trackdesk-green text-white',
		inactiveStyles: 'bg-trackdesk-green text-white',
		borderColor: 'border-trackdesk-green',
		highlightColor: 'bg-trackdesk-green',
	},
	{
		id: MembershipPlanId.ENTERPRISE,
		label: 'Enterprise',
		activeStyles: 'bg-trackdesk-green-muted text-dark',
		inactiveStyles: 'bg-trackdesk-green-muted text-dark',
		borderColor: 'border-trackdesk-green-muted',
		highlightColor: 'bg-trackdesk-green-muted',
	},
	{
		id: MembershipPlanId.NETWORK,
		label: 'Network',
		activeStyles: 'bg-orange-trackdesk text-dark',
		inactiveStyles: 'bg-orange-trackdesk text-dark',
		borderColor: 'border-orange-trackdesk',
		highlightColor: 'bg-orange-trackdesk',
	},
]
